var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCli(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 34.194916,
    y: 88.05191,
    width: 439.40466,
    height: 271.84958,
    id: "rect275"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#000000",
      strokeWidth: 1.05708
    },
    id: "rect111",
    width: 504.37497,
    height: 329.12607,
    x: 4.2743645,
    y: 62.405724,
    ry: 56.214371
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    id: "text273",
    style: {
      fontSize: 240,
      whiteSpace: "pre",
      shapeInside: "url(#rect275)",
      display: "inline",
      fill: "#000000"
    },
    transform: "matrix(1.3631318,0,0,1.3631318,-9.4121127,-76.850851)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 34.195312,
    y: 308.59961,
    id: "tspan431"
  }, /*#__PURE__*/React.createElement("tspan", {
    style: {
      fontWeight: "bold",
      fontFamily: "Bahnschrift",
      InkscapeFontSpecification: "'Bahnschrift Bold'",
      fill: "#ffffff"
    },
    id: "tspan429"
  }, "$&gt;")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCli);
export default __webpack_public_path__ + "static/media/cli.f81eb53d8c8098446d49a14194854b9b.svg";
export { ForwardRef as ReactComponent };